import fetchExpresso from 'utility/fetchExpresso';

export async function getHostPricingForHost(hostId) {
    const response = await fetchExpresso(`/apiv2/hosts/${hostId}/host_pricing?all=true`);

    if (response.status === 200) {
        const results = await response.json();
        return results;
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}

export async function getHostPricing(hostId, hostPricingId) {
    const response = await fetchExpresso(`/apiv2/hosts/${hostId}/host_pricing/${hostPricingId}`);

    if (response.status === 200) {
        const results = await response.json();
        return results;
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}

export async function setDefaultHostPricing(hostId, hostPricingId) {
    const response = await fetchExpresso(
        `/apiv2/hosts/${hostId}/host_pricing/${hostPricingId}/status`,
        { method: 'PATCH' },
    );

    if (response.status === 200) {
        return { success: true };
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}

export async function createHostPricing(hostId, values) {
    const response = await fetchExpresso(`/apiv2/hosts/${hostId}/host_pricing`, {
        method: 'POST',
        body: {
            setDefault: false,
            fields: values,
        },
    });

    if (response.status === 200) {
        return { success: true };
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}

export async function editHostPricing(hostId, hostPricingId, values) {
    const response = await fetchExpresso(`/apiv2/hosts/${hostId}/host_pricing/${hostPricingId}`, {
        method: 'PUT',
        body: {
            setDefault: false,
            fields: values,
        },
    });

    if (response.status === 200) {
        return { success: true };
    } else if (response.status === 409) {
        throw new Error(`[409] This host pricing is currently in use and cannot be edited`);
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}

/**
 * Fetches the default values used when creating a new host pricing record.
 * Note: this is not the same as the "Default Host Pricing" record which is the default pricing record applied to new events.
 */
export async function getDefaultHostPricingValues(hostId) {
    const response = await fetchExpresso(`/apiv2/hosts/${hostId}/host_pricing/defaults`);

    if (response.status === 200) {
        const { defaults } = await response.json();
        return defaults;
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}

export async function editHostPricingName(hostId, hostPricingId, name) {
    const response = await fetchExpresso(
        `/apiv2/hosts/${hostId}/host_pricing/${hostPricingId}/name`,
        {
            method: 'PATCH',
            body: { name: name },
        },
    );

    if (response.status === 200) {
        return { success: true };
    } else if (response.status === 409) {
        throw new Error(`[409] This host pricing is currently in use and cannot be edited`);
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}

export async function deleteHostPricing(hostId, hostPricingId) {
    const response = await fetchExpresso(`/apiv2/hosts/${hostId}/host_pricing/${hostPricingId}`, {
        method: 'DELETE',
    });

    if (response.status === 200) {
        return { success: true };
    } else if (response.status === 409) {
        throw new Error(`[409] This host pricing is currently in use and cannot be deleted`);
    } else {
        throw new Error(`[${response.status}] Something went wrong`);
    }
}
